import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.791.209a.713.713 0 0 0-1.009 0L5 3.99 1.218.21a.713.713 0 1 0-1.01 1.009L3.992 5 .21 8.782a.713.713 0 1 0 1.009 1.01L5 6.008 8.782 9.79a.713.713 0 0 0 1.01-1.009L6.008 5 9.79 1.218a.713.713 0 0 0 0-1.01Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }